module.exports = __webpack_public_path__ + "media/V_final.130c894c.mp4";